import { IconButton, InputAdornment, TextFieldProps } from '@mui/material';
import { useState } from 'react';
import ControlledTextField from '../../inputs/forms/controlled-text-field/controlled-text-field';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Control, FieldPath, FieldValues } from 'react-hook-form';

interface ControlledPasswordField<TFieldValues extends FieldValues = FieldValues> extends Omit<
  TextFieldProps,
  'name'
> {
  name: FieldPath<TFieldValues>;
  control: Control<TFieldValues>;
}

export function ControlledPassword<TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  ...textFieldProps
}: ControlledPasswordField<TFieldValues>) {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <ControlledTextField
      control={control}
      name={name}
      type={showPassword ? 'text' : 'password'}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={showPassword ? 'hide the password' : 'display the password'}
                onClick={() => setShowPassword((prev) => !prev)}
                edge="end"
                // §VI — >=44px touch target; MUI's IconButton default is 37px. See the matching
                // note in login-credentials-section.tsx.
                sx={{ minWidth: 44, minHeight: 44 }}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
      {...textFieldProps}
    />
  );
}
